// extracted by mini-css-extract-plugin
export default {"heading":"Dq-z","signin":"Eq-z","signupBtn":"Fq-z","disabled":"Gq-z"};